/*=============================================== ButtonIconPage ===============================================*/

import { ButtonIcon, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const ButtonIconPage = () => {
    const items: ItemType[] = [
        {
            title: "Plain",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon icon="mail" variant="plain" color="primary" />
                    <ButtonIcon icon="mail" variant="plain" color="secondary" />
                    <ButtonIcon icon="mail" variant="plain" color="success" />
                    <ButtonIcon icon="mail" variant="plain" color="danger" />
                    <ButtonIcon icon="mail" variant="plain" color="warning" />
                    <ButtonIcon icon="mail" variant="plain" color="white" />
                    <ButtonIcon icon="mail" variant="plain" color="font" />
                    <ButtonIcon
                        icon="mail"
                        variant="plain"
                        color="background"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="plain"
                        color="primary"
                        disabled
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="plain" color="primary" />\n<ButtonIcon icon="mail" variant="plain" color="secondary" />\n<ButtonIcon icon="mail" variant="plain" color="success" />\n<ButtonIcon icon="mail" variant="plain" color="danger" />\n<ButtonIcon icon="mail" variant="plain" color="warning" />\n<ButtonIcon icon="mail" variant="plain" color="white" />\n<ButtonIcon icon="mail" variant="plain" color="font" />\n<ButtonIcon icon="mail" variant="plain" color="background" />\n<ButtonIcon icon="mail" variant="plain" color="primary" disabled />',
        },
        {
            title: "Transparent",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="primary"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="secondary"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="success"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="danger"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="warning"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="white"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="font"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="background"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="transparent"
                        color="primary"
                        disabled
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="transparent" color="primary" />\n<ButtonIcon icon="mail" variant="transparent" color="secondary" />\n<ButtonIcon icon="mail" variant="transparent" color="success" />\n<ButtonIcon icon="mail" variant="transparent" color="danger" />\n<ButtonIcon icon="mail" variant="transparent" color="warning" />\n<ButtonIcon icon="mail" variant="transparent" color="white" />\n<ButtonIcon icon="mail" variant="transparent" color="font" />\n<ButtonIcon icon="mail" variant="transparent" color="background" />\n<ButtonIcon icon="mail" variant="transparent" color="primary" disabled />',
        },
        {
            title: "Ghost",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon icon="mail" variant="ghost" color="primary" />
                    <ButtonIcon icon="mail" variant="ghost" color="secondary" />
                    <ButtonIcon icon="mail" variant="ghost" color="success" />
                    <ButtonIcon icon="mail" variant="ghost" color="danger" />
                    <ButtonIcon icon="mail" variant="ghost" color="warning" />
                    <ButtonIcon icon="mail" variant="ghost" color="white" />
                    <ButtonIcon icon="mail" variant="ghost" color="font" />
                    <ButtonIcon
                        icon="mail"
                        variant="ghost"
                        color="background"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="ghost"
                        color="primary"
                        disabled
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="ghost" color="primary" />\n<ButtonIcon icon="mail" variant="ghost" color="secondary" />\n<ButtonIcon icon="mail" variant="ghost" color="success" />\n<ButtonIcon icon="mail" variant="ghost" color="danger" />\n<ButtonIcon icon="mail" variant="ghost" color="warning" />\n<ButtonIcon icon="mail" variant="ghost" color="white" />\n<ButtonIcon icon="mail" variant="ghost" color="font" />\n<ButtonIcon icon="mail" variant="ghost" color="background" />\n<ButtonIcon icon="mail" variant="ghost" color="primary" disabled />',
        },
        {
            title: "With link",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon
                        icon="mail"
                        variant="ghost"
                        color="primary"
                        to="/"
                    />
                    <ButtonIcon
                        icon="mail"
                        variant="plain"
                        color="secondary"
                        href="https://www.google.com/"
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="ghost" color="primary" to="/" />\n<ButtonIcon icon="mail" variant="plain" color="secondary" href="https://www.google.com/" />',
        },
        {
            title: "Loading",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon
                        icon="mail"
                        variant="plain"
                        color="success"
                        isLoading
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="plain" color="success" isLoading />',
        },
        {
            title: "With label",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <ButtonIcon
                        icon="mail"
                        variant="plain"
                        color="warning"
                        label="Label"
                        showLabel
                    />
                </Flexbox>
            ),
            code: '<ButtonIcon icon="mail" variant="plain" color="warning" label="Label" showLabel />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
            required: true,
        },
        {
            subtitle: "variant",
            type: "string",
            possible: ["plain", "transparent", "ghost"],
            default: "plain",
        },
        {
            subtitle: "size",
            type: "number",
            default: 48,
        },
        {
            subtitle: "iconSize",
            type: "number",
            default: "size * 0.7",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "isLoading",
            type: "boolean",
        },
        {
            subtitle: "loaderBorder",
            intro: (
                <>
                    Only if <code>isLoading</code> is defined.
                </>
            ),
            type: "number",
            default: 4,
        },
        {
            subtitle: "label",
            intro: (
                <>
                    This also adds a <code>aria-label</code>.
                </>
            ),
            type: "string",
        },
        "separator",
        {
            subtitle: "showLabel",
            intro: (
                <>
                    Only if the <code>label</code> prop is defined.
                </>
            ),
            type: "boolean or object",
        },
        {
            title: (
                <>
                    <code>showLabel</code> object
                </>
            ),
            subtitle: "position",
            type: "string",
            possible: ["up", "down"],
            default: "up",
        },
        {
            subtitle: "bottom",
            intro: "Position from the bottom.",
            type: "string or number",
            default: "125%",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ButtonIconPage
